module.exports = __webpack_public_path__ + "static/media/02.0d57112f.png";